/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AgencyReportSearchCriteriaDto { 
    agencyId?: string;
    agencyStatusType?: AgencyReportSearchCriteriaDto.AgencyStatusTypeEnum;
    isTestAgency?: boolean;
}
export namespace AgencyReportSearchCriteriaDto {
    export const AgencyStatusTypeEnum = {
        Approved: 'Approved',
        BeingReviewed: 'Being Reviewed',
        Denied: 'Denied',
        Inactive: 'Inactive',
        NotSubmitted: 'Not Submitted',
        RenewalAlert: 'Renewal Alert',
        RenewalExpired: 'Renewal Expired',
        RenewalWarning: 'Renewal Warning',
        ResubmissionRequired: 'Resubmission Required',
        ResubmissionRequiredImmediately: 'Resubmission Required Immediately'
    } as const;
    export type AgencyStatusTypeEnum = typeof AgencyStatusTypeEnum[keyof typeof AgencyStatusTypeEnum];
}


